<ng-container>
    <section class="hotelLayout">
    <div class="wrapperCard">
      <mat-card>
        <section class="headerDetails">
          <div class="heading">
            <h3></h3>
            <div class="starRating">
            </div>
          </div>
          <p class="location">
            
        </p>
        </section>
        <section class="hotelViewSection">
          <div class="wrapper">
            <div class="hotelWrapperImage">
                <ul>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                  </ul>
            </div>
          </div>
          <div class="wrapper hotelsDetails">
            <div class="innerWrapper checkInOutCard">
              <p><br><span ></span></p>
              <p><br><span></span></p>
            </div>
            <ng-container>
              <div class="innerWrapper mapDetails">
                <div class="mapBox">
                  <div class="overlay">
                  </div>
                </div>
                <div class="mapDescription">
                  <ul class="nearByHotel">
                    <li>
                      <span></span><span></span>
                    </li>
                  </ul>
                  <p></p>
                  <a mat-button color="primary"></a>
                </div>
              </div>
            </ng-container>
          </div>
        </section>
      </mat-card>
    </div>
    <section class="tabTreeSection">
      <ul>
          <li class="active"><span></span></li>
          <li ><span></span></li>
          <li><span> </span></li>
          <li><span></span></li>
      </ul>
    </section>
    <section id="roomOptionSection" class="roomOptionSection">
      <h3 class="subHeadingTitle"></h3>
      <ng-container >
        <ng-container>
          <mat-card >
            <div class="roomTitle">
              <h4></h4>
            </div>
            <div class="roomWrapper">
              <div class="innerWrapper">
                <p class="optionsTitle"></p>
                    <div class="radioOption">
                    </div>
              </div>
              <div class="innerWrapper inclusionList">
                <p class="optionsTitle"></p>
                <ul>
                  <li>
                    <p>
                     </p>
                  </li>
                </ul>
              </div>
              <div class="innerWrapper amenitiesList">
                <p class="optionsTitle"> </p>
                <ul>
                  <li>
                    <p class="amenitiesItemName" > </p>
                  </li>
                  <li>
                    <p class="amenitiesItemName" > </p>
                  </li>
                </ul>
              </div>
              <div class="innerWrapper paymentList">
                <section class="amountSection">
                  <div class="amount">
                    <p>
                      <span class="priceAmount"></span>
                    </p>
                    <p></p>
                  </div>
                  <button mat-button class="secoundaryBtn"></button>
                </section>
              </div>
            </div>
          </mat-card>
        </ng-container>
      </ng-container>
    </section>

    <section id="hotelDescription" class="hotelDescriptionSection">
      <h3 class="subHeadingTitle"> </h3>
      <mat-card>
        <p></p>
      </mat-card>
    </section>

    <!-- <section id="hotelPolicies" class="hotelPoliciesSection" >
      <h3 class="subHeadingTitle"></h3>
      <mat-card>
        <p></p>
      </mat-card>
    </section> -->

    <section id="facilities" class="facilitiesSection">
      <h3 class="subHeadingTitle"></h3>
      <mat-card>
        <div class="roomTitle">
          <h4></h4>
        </div>
        <ul class="facilitiesList">
          <ng-container>
            <li>
            </li>
          </ng-container>
        </ul>
      </mat-card>
    </section>
    </section>
</ng-container>
